import script from "./GraficasPediatria.vue?vue&type=script&setup=true&lang=js"
export * from "./GraficasPediatria.vue?vue&type=script&setup=true&lang=js"

import "./GraficasPediatria.vue?vue&type=style&index=0&id=38e199f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e199f8"]])

export default __exports__